"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = DateRangeModal;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_calendars_1 = require("react-native-calendars");
const react_i18next_1 = require("react-i18next");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const Helper_1 = require("../Helper");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const Button_1 = __importDefault(require("./Button"));
const toDateString = (d) => {
    if (!d || isNaN(d.getTime()))
        return '';
    const yyyy = d.getFullYear();
    const mm = (d.getMonth() + 1).toString().padStart(2, '0');
    const dd = d.getDate().toString().padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};
const parseDateStringYYYYMMDD = (s) => {
    if (!s)
        return null;
    const parts = s.split('-').map(Number);
    if (parts.length !== 3 || isNaN(parts[0]) || isNaN(parts[1]) || isNaN(parts[2]))
        return null;
    return new Date(parts[0], parts[1] - 1, parts[2]);
};
const formatCardDate = (dateStr, lang) => {
    if (!dateStr)
        return { main: '', year: '' };
    const d = parseDateStringYYYYMMDD(dateStr);
    if (!d)
        return { main: '', year: '' };
    const main = d.toLocaleDateString(lang, { weekday: 'short', month: 'short', day: 'numeric' });
    const year = d.getFullYear().toString();
    return { main, year };
};
function DateRangeModal(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const lang = Helper_1.Helper.deviceLanguage();
    const [isRendered, setIsRendered] = (0, react_1.useState)(props.visible);
    const containerHeightRef = (0, react_1.useRef)(400);
    const animY = (0, react_1.useRef)(new react_native_1.Animated.Value(400)).current;
    const isDismissingRef = (0, react_1.useRef)(false);
    const scrollRef = (0, react_1.useRef)(null);
    const [tempStartDate, setTempStartDate] = (0, react_1.useState)(toDateString(props.startDate));
    const [tempEndDate, setTempEndDate] = (0, react_1.useState)(toDateString(props.endDate));
    const [activeField, setActiveField] = (0, react_1.useState)(props.initialField ?? (props.startDate ? 'end' : 'start'));
    const [currentMonth, setCurrentMonth] = (0, react_1.useState)(toDateString(props.startDate) || toDateString(new Date()));
    const useNative = react_native_1.Platform.OS !== 'web';
    (0, react_1.useEffect)(() => {
        if (props.visible) {
            isDismissingRef.current = false;
            scrollRef.current?.scrollTo({ y: 0, animated: false });
            const s = toDateString(props.startDate);
            const e = toDateString(props.endDate);
            setTempStartDate(s || null);
            setTempEndDate(e || null);
            setActiveField(props.initialField ?? (s && !e ? 'end' : 'start'));
            setCurrentMonth(s || toDateString(new Date()));
            setIsRendered(true);
            const h = containerHeightRef.current || 400;
            animY.setValue(h);
            react_native_1.Animated.timing(animY, {
                toValue: 0,
                duration: 280,
                easing: react_native_1.Easing.out(react_native_1.Easing.cubic),
                useNativeDriver: useNative,
            }).start();
        }
        else if (isRendered && !isDismissingRef.current) {
            const h = containerHeightRef.current || 400;
            react_native_1.Animated.timing(animY, {
                toValue: h,
                duration: 220,
                easing: react_native_1.Easing.in(react_native_1.Easing.cubic),
                useNativeDriver: useNative,
            }).start(() => {
                setIsRendered(false);
            });
        }
    }, [props.visible, props.startDate, props.endDate, props.initialField]);
    const handleLayout = (e) => {
        const h = e.nativeEvent.layout.height;
        if (h > 0) {
            containerHeightRef.current = h;
        }
    };
    const handleDismiss = () => {
        if (isDismissingRef.current)
            return;
        isDismissingRef.current = true;
        const h = containerHeightRef.current || 600;
        react_native_1.Animated.timing(animY, {
            toValue: h,
            duration: 220,
            easing: react_native_1.Easing.in(react_native_1.Easing.cubic),
            useNativeDriver: useNative,
        }).start(() => {
            setIsRendered(false);
            isDismissingRef.current = false;
            props.onDismiss();
        });
    };
    const handleDayPress = (day) => {
        const clicked = day.dateString;
        if (activeField === 'start') {
            setTempStartDate(clicked);
            if (tempEndDate && clicked > tempEndDate) {
                setTempEndDate(null);
            }
            // Auto-advance to 'end' leg like Southwest Airlines
            setActiveField('end');
        }
        else {
            // activeField === 'end'
            if (!tempStartDate) {
                setTempStartDate(clicked);
                setActiveField('end');
            }
            else if (clicked < tempStartDate) {
                // If user clicks a date earlier than start date, reset start date to that date
                setTempStartDate(clicked);
                setTempEndDate(null);
                setActiveField('end');
            }
            else {
                setTempEndDate(clicked);
            }
        }
    };
    const handleConfirm = () => {
        if (!tempStartDate)
            return;
        const start = parseDateStringYYYYMMDD(tempStartDate);
        const end = tempEndDate ? parseDateStringYYYYMMDD(tempEndDate) : start;
        if (start && end) {
            const [finalStart, finalEnd] = start.getTime() <= end.getTime()
                ? [start, end]
                : [end, start];
            if (isDismissingRef.current)
                return;
            isDismissingRef.current = true;
            const h = containerHeightRef.current || 600;
            react_native_1.Animated.timing(animY, {
                toValue: h,
                duration: 220,
                easing: react_native_1.Easing.in(react_native_1.Easing.cubic),
                useNativeDriver: useNative,
            }).start(() => {
                setIsRendered(false);
                isDismissingRef.current = false;
                props.onConfirm(finalStart, finalEnd);
            });
        }
    };
    const handleClear = () => {
        setTempStartDate(null);
        setTempEndDate(null);
        setActiveField('start');
    };
    const markedDates = (0, react_1.useMemo)(() => {
        const marks = {};
        if (!tempStartDate && !tempEndDate) {
            return marks;
        }
        if (tempStartDate && !tempEndDate) {
            marks[tempStartDate] = {
                startingDay: true,
                endingDay: true,
                color: THEME.Primary,
                textColor: THEME.AlwaysWhite ?? '#FFFFFF',
                customContainerStyle: {
                    backgroundColor: THEME.Primary,
                    borderRadius: 17,
                },
            };
            return marks;
        }
        if (!tempStartDate && tempEndDate) {
            marks[tempEndDate] = {
                startingDay: true,
                endingDay: true,
                color: THEME.Primary,
                textColor: THEME.AlwaysWhite ?? '#FFFFFF',
                customContainerStyle: {
                    backgroundColor: THEME.Primary,
                    borderRadius: 17,
                },
            };
            return marks;
        }
        if (tempStartDate && tempEndDate) {
            if (tempStartDate === tempEndDate) {
                marks[tempStartDate] = {
                    startingDay: true,
                    endingDay: true,
                    color: THEME.Primary,
                    textColor: THEME.AlwaysWhite ?? '#FFFFFF',
                    customContainerStyle: {
                        backgroundColor: THEME.Primary,
                        borderRadius: 17,
                    },
                };
                return marks;
            }
            const [startStr, endStr] = tempStartDate <= tempEndDate
                ? [tempStartDate, tempEndDate]
                : [tempEndDate, tempStartDate];
            const start = parseDateStringYYYYMMDD(startStr);
            const end = parseDateStringYYYYMMDD(endStr);
            if (!start || !end)
                return marks;
            marks[startStr] = {
                startingDay: true,
                color: THEME.PrimaryLightest ?? '#F0F1F8',
                textColor: THEME.AlwaysWhite ?? '#FFFFFF',
                customContainerStyle: {
                    backgroundColor: THEME.Primary,
                    borderRadius: 17,
                },
            };
            marks[endStr] = {
                endingDay: true,
                color: THEME.PrimaryLightest ?? '#F0F1F8',
                textColor: THEME.AlwaysWhite ?? '#FFFFFF',
                customContainerStyle: {
                    backgroundColor: THEME.Primary,
                    borderRadius: 17,
                },
            };
            const cur = new Date(start);
            cur.setDate(cur.getDate() + 1);
            while (cur.getTime() < end.getTime()) {
                const key = toDateString(cur);
                marks[key] = {
                    color: THEME.PrimaryLightest ?? '#F0F1F8',
                    textColor: THEME.Primary,
                };
                cur.setDate(cur.getDate() + 1);
            }
        }
        return marks;
    }, [tempStartDate, tempEndDate, THEME.Primary, THEME.PrimaryLightest, THEME.AlwaysWhite]);
    const startFormatted = (0, react_1.useMemo)(() => formatCardDate(tempStartDate, lang), [tempStartDate, lang]);
    const endFormatted = (0, react_1.useMemo)(() => formatCardDate(tempEndDate, lang), [tempEndDate, lang]);
    const styles = (0, react_1.useMemo)(() => createStyles(THEME), [THEME]);
    if (!isRendered) {
        return null;
    }
    const renderDatePickerContent = () => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!props.hideTitle && ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.headerRow, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.DuoTone.CalendarClock, size: 18, color: THEME.Secondary }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: [styles.headerTitle, { color: THEME.Text, marginLeft: 8 }], children: t('time:buttons.adjustDates', 'Select Dates') })] }), (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { hitSlop: 12, onPress: handleDismiss, accessibilityRole: "button", accessibilityLabel: t('common:buttons.cancel'), style: { padding: 4 }, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 16, color: THEME.Text }) })] })), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.tabContainer, children: [(0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { style: [
                            styles.tabCard,
                            activeField === 'start' ? styles.activeTabCard : styles.inactiveTabCard,
                        ], onPress: () => setActiveField('start'), accessibilityRole: "tab", accessibilityState: { selected: activeField === 'start' }, accessibilityLabel: `${t('common:text.startDate')}: ${startFormatted.main || t('common:text.selectDate', 'Select date')}`, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: [
                                    styles.tabLabel,
                                    { color: activeField === 'start' ? THEME.Secondary : (THEME.TextLight ?? '#64748B') },
                                ], children: Helper_1.Helper.FormatTitleCase(t('common:text.startDate')) }), tempStartDate ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: [styles.tabDateText, { color: THEME.Text }], numberOfLines: 1, children: startFormatted.main }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: [styles.tabYearText, { color: THEME.TextLight ?? '#64748B' }], children: startFormatted.year })] })) : ((0, jsx_runtime_1.jsx)(react_native_1.Text, { style: [styles.tabPlaceholderText, { color: THEME.TextLight ?? '#94A3B8' }], children: t('common:text.selectDate', 'Select date') }))] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.arrowContainer, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.ArrowRight, size: 12, color: THEME.TextLight ?? '#94A3B8' }) }), (0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { style: [
                            styles.tabCard,
                            activeField === 'end' ? styles.activeTabCard : styles.inactiveTabCard,
                        ], onPress: () => setActiveField('end'), accessibilityRole: "tab", accessibilityState: { selected: activeField === 'end' }, accessibilityLabel: `${t('common:text.endDate')}: ${endFormatted.main || t('common:text.selectDate', 'Select date')}`, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: [
                                    styles.tabLabel,
                                    { color: activeField === 'end' ? THEME.Secondary : (THEME.TextLight ?? '#64748B') },
                                ], children: Helper_1.Helper.FormatTitleCase(t('common:text.endDate')) }), tempEndDate ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: [styles.tabDateText, { color: THEME.Text }], numberOfLines: 1, children: endFormatted.main }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: [styles.tabYearText, { color: THEME.TextLight ?? '#64748B' }], children: endFormatted.year })] })) : ((0, jsx_runtime_1.jsx)(react_native_1.Text, { style: [styles.tabPlaceholderText, { color: THEME.TextLight ?? '#94A3B8' }], children: t('common:text.selectDate', 'Select date') }))] })] }), (0, jsx_runtime_1.jsx)(react_native_calendars_1.Calendar, { current: currentMonth, headerStyle: { paddingBottom: 12 }, minDate: props.minDate, maxDate: props.maxDate, onMonthChange: (month) => setCurrentMonth(month.dateString), markingType: "period", markedDates: markedDates, onDayPress: handleDayPress, renderArrow: (direction) => ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Primary, icon: direction === 'left' ? Theme_1.ICONS.Regular.ChevronLeft : Theme_1.ICONS.Regular.ChevronRight, size: 12 })), theme: {
                    calendarBackground: THEME.CardBackground,
                    textSectionTitleColor: THEME.TextLight ?? '#64748B',
                    selectedDayBackgroundColor: THEME.Primary,
                    selectedDayTextColor: THEME.AlwaysWhite ?? '#FFFFFF',
                    todayTextColor: THEME.Secondary,
                    dayTextColor: THEME.Text,
                    textDisabledColor: `${THEME.Text}33`,
                    monthTextColor: THEME.Text,
                    textDayFontWeight: '500',
                    textMonthFontWeight: '700',
                    textDayHeaderFontWeight: '600',
                    textDayFontSize: 12,
                    textMonthFontSize: 13,
                    textDayHeaderFontSize: 10,
                    'stylesheet.day.period': {
                        base: {
                            width: 34,
                            height: 34,
                            alignItems: 'center',
                            justifyContent: 'center',
                        },
                    },
                    'stylesheet.calendar.header': {
                        header: {
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            paddingLeft: 6,
                            paddingRight: 6,
                            marginTop: 0,
                            marginBottom: 0,
                            paddingBottom: 12,
                            alignItems: 'center',
                        },
                        monthText: {
                            fontSize: 13,
                            fontWeight: '700',
                            color: THEME.Text,
                            margin: 2,
                        },
                        arrow: {
                            padding: 2,
                        },
                        week: {
                            marginTop: 0,
                            marginBottom: 2,
                            flexDirection: 'row',
                            justifyContent: 'space-around',
                        },
                    },
                }, style: {
                    borderRadius: 4,
                } }, `range-calendar-${currentMonth}`), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.footerRow, { marginTop: size === 'sm' ? 12 : 4 }], children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.buttonWrapper, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: "outline", text: t('common:buttons.cancel'), onPress: handleDismiss }) }), (tempStartDate != null || tempEndDate != null) && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.buttonWrapper, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: "outline", text: t('common:buttons.clear', 'Clear'), onPress: handleClear }) })), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.buttonWrapper, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: "solid", text: t('common:buttons.confirm'), disabled: !tempStartDate, color: THEME.Primary, onPress: handleConfirm }) })] })] }));
    return ((0, jsx_runtime_1.jsx)(react_native_1.Animated.View, { style: [
            styles.container,
            {
                transform: [{ translateY: animY }],
            },
        ], onLayout: handleLayout, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: size === 'sm' ? styles.mobileContent : styles.scrollContent, children: renderDatePickerContent() }) }));
}
const createStyles = (THEME) => react_native_1.StyleSheet.create({
    container: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: THEME.CardBackground,
        zIndex: 100,
        borderRadius: 4,
        overflow: 'hidden',
    },
    mobileContent: {
        paddingHorizontal: 12,
        paddingTop: 8,
        paddingBottom: 16,
        justifyContent: 'flex-start',
    },
    scrollContent: {
        paddingHorizontal: 12,
        paddingTop: 4,
        paddingBottom: 4,
        flex: 1,
        justifyContent: 'space-between',
    },
    headerRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 4,
    },
    headerTitle: {
        fontSize: 16,
        fontWeight: '600',
    },
    tabContainer: {
        flexDirection: 'row',
        alignItems: 'stretch',
        marginBottom: 4,
    },
    tabCard: {
        flex: 1,
        borderRadius: 4,
        paddingTop: 3,
        paddingHorizontal: 8,
        paddingBottom: 3,
        borderWidth: 1.5,
        minHeight: 46,
        justifyContent: 'space-between',
    },
    activeTabCard: {
        borderColor: THEME.Secondary,
        backgroundColor: `${THEME.Secondary}10`,
    },
    inactiveTabCard: {
        borderColor: THEME.OffWhiteDark ?? '#E2E8F0',
        backgroundColor: THEME.OffWhite ?? '#F8FAFC',
    },
    tabLabel: {
        fontSize: 10,
        fontWeight: '700',
        letterSpacing: 0.6,
        marginBottom: 1,
    },
    tabDateText: {
        fontSize: 13,
        fontWeight: '700',
    },
    tabYearText: {
        fontSize: 10,
        fontWeight: '500',
    },
    tabPlaceholderText: {
        fontSize: 12,
        fontWeight: '500',
        fontStyle: 'italic',
        marginTop: 1,
        marginBottom: 1,
    },
    arrowContainer: {
        paddingHorizontal: 4,
        justifyContent: 'center',
        alignItems: 'center',
    },
    promptContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 2,
    },
    promptText: {
        fontSize: 11,
        fontWeight: '600',
    },
    footerRow: {
        flexDirection: 'row',
        marginTop: 6,
        marginHorizontal: -4,
    },
    buttonWrapper: {
        flex: 1,
        marginHorizontal: 4,
    },
});
